import React, { useState } from "react";

import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";

import { getTranslateByKey } from "@/main/services/utils";
import Close from "@mui/icons-material/Close";

import { RefreshQuoteByGetItemsType, TypeBoxCart } from "./types";
import * as S from "../styles";
import ModalConfirmCancelPart from "./modalConfirmCancelPart/modalConfirmCancelPart";
import { showMessageWhenPaymentPending } from "./utilsBoxCart";
import { CartState } from "@/main/store/cart";

interface IButtonDeletePartProps {
	type?: TypeBoxCart;
	guidQuoteItem: string;
	idButtonDeletePart: string;
	partName?: string | null;
	callbackAfterRemovePart?: (hasLastPartInCart: boolean) => void;
	refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
	guidQuoteSupplierItem?: string | null;
	isQuoteCanceled: boolean;
	isPaymentPending: boolean;
	isQuoteBlocked: boolean;
	guidQuote: string;
	dataCart: CartState;
}
function ButtonDeletePart({
	guidQuoteItem,
	idButtonDeletePart,
	isPaymentPending,
	isQuoteBlocked,
	isQuoteCanceled,
	type = "unaswered",
	refreshQuoteByGetItems,
	callbackAfterRemovePart = () => {},
	guidQuoteSupplierItem,
	guidQuote,
	dataCart,
}: IButtonDeletePartProps) {
	const [openModalRemovePart, setOpenModalRemovePart] = useState<boolean>(false);

	function handleButtonDeletePart(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		e.stopPropagation();
		if (isPaymentPending) return showMessageWhenPaymentPending();

		setOpenModalRemovePart(true);
	}

	function showButtonRemovePart() {
		if (isQuoteCanceled || isQuoteBlocked) {
			return false;
		}
		return true;
	}

	if (!showButtonRemovePart()) {
		return <></>;
	}

	return (
		<>
			<TooltipComponent title={`${getTranslateByKey("reasonType.cancelPart")}`} placement="top">
				<S.IconButtonClose onClick={handleButtonDeletePart} disabled={false}>
					<Close id={idButtonDeletePart} fontSize="small" />
				</S.IconButtonClose>
			</TooltipComponent>
			<ModalConfirmCancelPart
				type={type}
				dataCart={dataCart}
				refreshQuoteByGetItems={refreshQuoteByGetItems}
				guidQuote={guidQuote}
				guidsQuoteItem={[guidQuoteItem]}
				openModalConfirm={openModalRemovePart}
				setOpenModalConfirm={setOpenModalRemovePart}
				callbackAfterRemovePart={callbackAfterRemovePart}
				guidQuoteSupplierItem={guidQuoteSupplierItem}
			/>
		</>
	);
}

export default ButtonDeletePart;
